import { FC } from "react";
import Authentication from "components/authentication/Authentication";
import Destinations from "components/pays/Pays";
import Destination from "components/pays/fiche-pays";
import Home from "components/home/Home";
import Messagerie from "components/messagerie/Messagerie";
import ListeProfils from "components/profils/Profils";
import CarnetVoyage from "components/carnetVoyage/CarnetVoyage";
import Passeport from "components/passeport/Passeport";
import PasseportVide from "components/passeport/passeport-vide";
import PasseportParametres from "components/passeport/parametres";
import Article from "components/carnetVoyage/article";
import ForgotPassword from "components/authentication/forgot-password";
import ReinitPassword from "components/authentication/reinit-password";
import UserProfil from "components/passeport/UserProfil";
import CvgPage from "components/authentication/cvg";
import ConfidentialityPage from "components/authentication/confidentiality";
import CookiesPage from "components/authentication/cookies";

interface Routes {
  path: string;
  search?: string;
  Component: FC<{}>;
  key: string;
}
export const privateRoutes: Routes[] = [
  {
    key: "route-messagerie",
    path: "/messagerie",
    Component: Messagerie,
  },
  {
    key: "route-passeport",
    path: "/passeport",
    Component: Passeport,
  },
  {
    key: "route-passeport-edition",
    path: "/passeport-edition",
    Component: PasseportVide,
  },
  {
    key: "route-parametres",
    path: "/parametres",
    Component: PasseportParametres,
  },
  {
    key: "route-public-user",
    path: "/user/:id",
    Component: UserProfil,
  }
];

export const publicRoutes: Routes[] = [
  {
    key: "route-liste-profils",
    path: "/liste-profils",
    Component: ListeProfils,
  },
  {
    key: "route-authentication",
    path: "/auth",
    Component: Authentication,
  },
  {
    key: 'reinit-password',
    path: '/reinitialiser-mot-de-passe/:access?',
    Component: ReinitPassword
  },
  {
    key: "route-forgot-password",
    path: "/mot-de-passer-oublie",
    Component: ForgotPassword
  },
  {
    key: "route-home",
    path: "/",
    Component: Home,
  },
  {
    key: "route-je-cherche-un-voyage",
    path: "/je-cherche-un-voyage",
    Component: Home,
  },
  // {
  //   key: "route-map",
  //   path: "/map",
  //   Component: Map,
  // },
  {
    key: "route-destinations",
    path: "/liste-pays",
    Component: Destinations,
  },
  {
    key: "route-destination-details",
    path: "/fiche-pays/:id",
    Component: Destination,
  },
  {
    key: "route-explorer-le-monde",
    path: "/explorer-le-monde",
    Component: CarnetVoyage,
  },
  {
    key: "route-article",
    path: "/article/:id",
    Component: Article,
  },
  {
    key: "route-article-slug",
    path: "/article/:id/:slug",
    Component: Article,
  },
  {
    key: 'route-cgu',
    path: '/conditions-generales-utilisation',
    Component: CvgPage
  },
  {
    key: 'route-confid',
    path: '/protection-des-donnees',
    Component: ConfidentialityPage
  },
  {
    key: 'route-cookies',
    path: '/politique-cookie',
    Component: CookiesPage
  }
];
